import * as Dialog from '@radix-ui/react-dialog';

import CrossIcon from '@bufferapp/ui/Icon/Icons/Cross';
import React from 'react';

import {
  CloseDialogButton,
  InnerWrapper,
  ModalWrapper,
  StyledOverlay,
} from './styles';

import { SearchImagesForm } from '../search-images-form/SearchImagesForm';
import { IntegrationsService, IntegrationsContext } from '../../types';

export const SearchImagesModal = ({
  open,
  handleClose,
  service,
  context: editor,
}: {
  open: boolean;
  handleClose: () => void;
  service: IntegrationsService | null;
  context: IntegrationsContext;
}) => {
  if (service === null) return <></>;

  const clickOutsideModal = (e) => {
    e.preventDefault();
    handleClose();
  };

  return (
    <Dialog.Root open={open} onOpenChange={handleClose}>
      <Dialog.Portal>
        <StyledOverlay />
        <ModalWrapper onPointerDownOutside={(e) => clickOutsideModal(e)}>
          <InnerWrapper data-testid="ideas-modal-window">
            <SearchImagesForm editor={editor} service={service} />
            <Dialog.Close asChild>
              <CloseDialogButton aria-label="Close" type="button">
                <CrossIcon />
              </CloseDialogButton>
            </Dialog.Close>
          </InnerWrapper>
        </ModalWrapper>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
